import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FinanciamentoService } from 'src/app/services/financiamento.services';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { PremissasSistema } from "../../models/premissas-sistema";

@Component({
  selector: 'app-integrador-modal',
  templateUrl: './integrador-modal.component.html',
  styleUrls: ['./integrador-modal.component.scss']
})
export class IntegradorModalComponent implements OnInit {

  idIntegrador;
  habilitaAbaFinanciadoras = false;

  modulosAtivos: number[] = [];
  premissasSistema: PremissasSistema = new PremissasSistema();

  constructor(public dialogRef: MatDialogRef<IntegradorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private financiamentoService: FinanciamentoService,
    private premissasService: PremissasService) {
    this.idIntegrador = data.idIntegrador;
  }

  async ngOnInit() {
    await this.buscarPremissasSistema();
    await this.buscarModulosAtivos();

    if (this.possuiModulo(15)) {
      this.buscarFinanciamentoConfig();
    }
  }

  async buscarPremissasSistema() {
    this.carregandoService.mostra('buscarPremissasSistema');
    this.premissasService.consultarPremissasSistema().subscribe(
      (premissas) => {
        this.premissasSistema = premissas;

        this.carregandoService.esconde('buscarPremissasSistema');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissasSistema');
        this.notificacaoService.erro(erro);
      }
    );
  }

  fechar() {
    this.dialogRef.close();
  }

  buscarFinanciamentoConfig() {
    this.carregandoService.mostra('buscarFinanciamentoConfig');

    this.financiamentoService.buscar().subscribe(
      (config) => {
        this.habilitaAbaFinanciadoras = config.result.ativo;
        this.carregandoService.esconde('buscarFinanciamentoConfig');
      },
      (erro) => {
        this.carregandoService.esconde('buscarFinanciamentoConfig');
        this.notificacaoService.erro(erro);
      }
    );
  }

  possuiModulo(modulo: Number) {
    return this.modulosAtivos.some(p => p === modulo);
  }

  async buscarModulosAtivos() {

    try {
      this.carregandoService.mostra('buscarModulosAtivos');

      this.modulosAtivos = await this.premissasService.consultarModulosAtivos().toPromise();

      this.carregandoService.esconde('buscarModulosAtivos');
    } catch (erro) {
      this.carregandoService.esconde('buscarModulosAtivos');
      this.notificacaoService.erro(erro);
    }
  }

}
